module["exports"] = [
  "#{Name.first_name} #{street_suffix}",
  "#{Name.last_name} #{street_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/street_name.js
// module id = 1394
// module chunks = 0